import React from 'react';
export function FooterSection() {
  return <footer className="py-12 border-t border-primary/10 mt-12" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col items-center" data-id="element-74">
        <p className="text-textSecondary text-sm mb-4 text-center" data-id="element-75">
          © {new Date().getFullYear()} Editing Arsenal. Todos los derechos
          reservados.
        </p>
        <div className="flex space-x-6 text-xs text-primary font-semibold" data-id="element-76">
          <a href="#" className="hover:text-white transition-colors" data-id="element-77">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-78">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-79">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}